import { useState, useEffect } from 'react';
import { Experiment, When } from '@carvana/core-experiment';

import HandRaiserToast from './HandRaiserToast';
import { DynamicHandRaiserToastProps } from './HandRaiserToast.types';

import { useDynamicHandraiser } from 'hooks/useDynamicHandraiser';
import { DynamicHandRaiserResponseType } from 'services/chatBackend/types/handraiser';

import { DataDogLogger } from 'utils/dataDog';
import { CUSTOM_ACTION_NAMES } from 'utils/dataDog/constants';

const DynamicHandRaiserToast = ({
  currentExperiment,
  handleCloseToast,
  handleStartChat,
  handleUpdateHandRaiserShown,
  handraiserName,
}: DynamicHandRaiserToastProps) => {
  const { name: experimentName, bucket: experimentBucket } = currentExperiment;

  const [dynamicHandraiserData, setDynamicHandraiserData] = useState<DynamicHandRaiserResponseType>(
    {
      buttonText: '',
      handraiserContext: undefined,
      handraiserId: '',
      handraiserName: '',
      showHandraiser: false,
      text: '',
    },
  );
  const [mayShowHandraiser, setMayShowHandraiser] = useState(false);

  const { getDynamicHandraiserData, runMayShowHandRaiser } = useDynamicHandraiser(handraiserName);

  useEffect(() => {
    (async () => {
      const { mayShow, error, reason } = await runMayShowHandRaiser();
      setMayShowHandraiser(mayShow);
      if (error) {
        DataDogLogger.error(new Error('Handraiser - show condition failed'), {
          currentExperiment,
          error,
          mayShow,
          reason,
          url: window.location.href,
        });
      }
    })();
  }, []);

  useEffect(() => {
    if (mayShowHandraiser) {
      (async () => {
        const data = await getDynamicHandraiserData();
        if (data) {
          setDynamicHandraiserData(data);
          if (data?.showHandraiser && !data?.text) {
            DataDogLogger.action(CUSTOM_ACTION_NAMES.DYNAMIC_HANDRAISER_NO_CONTENT, {
              url: window.location.href,
              currentExperiment,
              handraiserId: data.handraiserId,
              handraiserName,
            });
          }
        }
      })();
    }
  }, [mayShowHandraiser]);

  const dynamicHandRaiserProps = {
    handleCloseToast,
    handleUpdateHandRaiserShown,
    handleStartChat: () => handleStartChat(dynamicHandraiserData.text, dynamicHandraiserData),
    displayMessage: dynamicHandraiserData.text,
    openChatCTA: dynamicHandraiserData.buttonText,
    experimentName,
    handraiserName,
  };

  if (!mayShowHandraiser || !dynamicHandraiserData.showHandraiser) {
    return null;
  }

  return (
    <Experiment name={experimentName}>
      <When bucket={experimentBucket}>
        <HandRaiserToast {...dynamicHandRaiserProps} />
      </When>
    </Experiment>
  );
};

export default DynamicHandRaiserToast;
